import { ImportSagaState } from "../state";

export type ImportSagaActions =
  { type: ImportSagaAction.LoadSaga, versionId: number } |
  { type: ImportSagaAction.LoadSagaSuccess, result: ImportSagaState } |
  { type: ImportSagaAction.LoadSagaFailure, error: string };

export enum ImportSagaAction {
  LoadSaga = "LOAD_SAGA",
  LoadSagaSuccess = "LOAD_SAGA_SUCCESS",
  LoadSagaFailure = "LOAD_SAGA_FAILURE",
}
